import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d3d9976"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "documentBox layoutBox",
  id: "documentBox"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "documentBox_title" }, "操作文档", -1))
const _hoisted_4 = { class: "document_itemBox" }
const _hoisted_5 = { class: "document_item_top" }
const _hoisted_6 = { class: "document_item_menuName" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "更多", -1))
const _hoisted_9 = { class: "document_item_main" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "document_item_line_label" }, null, -1))
const _hoisted_12 = {
  class: "hotIssueBox layoutBox",
  id: "hotIssueBox"
}
const _hoisted_13 = { class: "hotIssue_top" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hotIssue_top_l" }, "热门问题", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "更多", -1))
const _hoisted_16 = { class: "hotIssue_main" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hotIssue_item_title_label" }, null, -1))
const _hoisted_19 = { class: "hotIssue_item_describe" }
const _hoisted_20 = {
  key: 1,
  class: "loadingBox"
}
const _hoisted_21 = { "element-loading-text": "载入中..." }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBox = _resolveComponent("NavBox")!
  const _component_arrow_right = _resolveComponent("arrow-right")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.documentList && _ctx.hotIssueList)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_NavBox, {
            selectedItem: _ctx.selectedItem,
            "onUpdate:selectedItem": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedItem) = $event)),
            ifHome: ""
          }, null, 8, ["selectedItem"]),
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              (_ctx.documentList.length)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.documentList, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "document_item",
                      key: item.id
                    }, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, _toDisplayString(item.name), 1),
                        _createElementVNode("div", {
                          class: "document_item_top_r",
                          onClick: ($event: any) => (_ctx.goDocumentList(item.name))
                        }, [
                          _hoisted_8,
                          _createVNode(_component_el_icon, {
                            size: "16",
                            color: "#999999"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_arrow_right)
                            ]),
                            _: 1
                          })
                        ], 8, _hoisted_7)
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        (item.children.length)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.children, (itemJ) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "document_item_line",
                                key: itemJ.id,
                                onClick: ($event: any) => (_ctx.goDocumentDetails(itemJ.id))
                              }, [
                                _hoisted_11,
                                _createElementVNode("span", null, _toDisplayString(itemJ.name), 1)
                              ], 8, _hoisted_10))
                            }), 128))
                          : (_openBlock(), _createBlock(_component_el_empty, {
                              key: 1,
                              description: "暂无内容",
                              "image-size": 80
                            }))
                      ])
                    ]))
                  }), 128))
                : (_openBlock(), _createBlock(_component_el_empty, {
                    key: 1,
                    description: "暂无内容",
                    class: "documentEmpty"
                  }))
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", {
                class: "hotIssue_top_r",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goHotIssueList()))
              }, [
                _hoisted_15,
                _createVNode(_component_el_icon, {
                  size: "16",
                  color: "#999999"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_arrow_right)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              (_ctx.hotIssueList.length)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.hotIssueList, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "hotIssue_item",
                      key: item.id
                    }, [
                      _createElementVNode("div", {
                        class: "hotIssue_item_title",
                        onClick: ($event: any) => (_ctx.goHotIssueDetails(item.id))
                      }, [
                        _hoisted_18,
                        _createElementVNode("span", null, _toDisplayString(item.name), 1)
                      ], 8, _hoisted_17),
                      _createElementVNode("div", _hoisted_19, _toDisplayString(item.answer), 1)
                    ]))
                  }), 128))
                : (_openBlock(), _createBlock(_component_el_empty, {
                    key: 1,
                    description: "暂无内容"
                  }))
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _withDirectives(_createElementVNode("div", _hoisted_21, null, 512), [
            [_directive_loading, _ctx.loading]
          ])
        ]))
  ]))
}